export default function ProductDimensions({
  selectedVariant,
  variantDetails,
  showOffsetBlockSelector
}) {
  const variant = selectedVariant.variantTitle
    .toLowerCase()
    .split('/')[0]
    .trim();

  const dimensions = variantDetails?.find(
    (detail) => detail?.variant_name?.toLowerCase() === variant
  )?.dimensions;

  const weight = variantDetails?.find(
    (detail) =>
      detail?.variant_name?.toLowerCase() === variant && detail?.weight
  )?.weight;

  return (
    <div
      className={`body-s text-dawn-grey-60 justify-right ${showOffsetBlockSelector === 'multi-block' ? '' : 'mt-2'} flex`}
    >
      <div>{dimensions}</div>
      {weight && weight != 0 && dimensions && <div className="px-1"> / </div>}
      {weight && <div>{weight}lbs</div>}
    </div>
  );
}
